// extracted by mini-css-extract-plugin
export default {"actions":"Asignaturas_actions__FHIJ1","download":"Asignaturas_download__vGPKp","mes":"Asignaturas_mes__Wn7c2"};